export enum PresetTypes {
  PROGRESS = 'PROGRESS',
  QUESTIONS = 'QUESTIONS',
}

export type PostMessageConnectionLtiClientApi = {
  setSlidesDictionary: (slideIds: string[]) => void;
  onChangeSlide: (slideId: string) => void;

  setInteractiveQuestionIds: (inteactiveQuestionIds: string[]) => void;
  onInteractiveQuestionAnswered: (args: {
    interactiveQuestionId: string;
    isCorrect: boolean;
  }) => void;
};
